import React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';

const SettingButtonIcon = styled(FontAwesomeIcon)({
    color: 'white',
    fontSize: '20px',
    userSelect: 'none',
    ':hover': {
        color: '#23527c',
    },
});

export type SettingButtonProps = {
    onClick: () => void;
}

export const SettingButton = (props: SettingButtonProps) => {
    return (
        <div onClick={props.onClick}>
            <SettingButtonIcon icon={faCog} />
        </div>
    );
};
